import { useContext, useEffect, useReducer, useRef, useState } from 'react';
import axios from 'axios';
import { dataFetchReducer } from './utils/dataFetchReducer';
import { systemCode, xs_languageCode } from '..';
import { parseMatchData } from './parseMatchData';
import { getConfiguration } from './utils/configuration';
import { BetslipContext } from './betslip/BetslipConf';

export function useFetchMatch(match, aggregata, isLive, reload, compattaParametriche) {
    const ctxs = useRef({}).current;
    ctxs.betslipContext =  useContext(BetslipContext);
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    const [isSetInterval,setIsSetInterval] = useState(false);
    
    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    if (result.data === '') {
                        dispatch({ type: 'FETCH_FAILURE' });
                    } else {
                        callback(result.data);
                    }
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        //const url = `${baseURL}/getEvento`;
        const url = getConfiguration().api.getEvento;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            pal: match.pal,
            avv: match.avv,
            idAggregata: aggregata,
            isLive: isLive
        };
        fetchData(url, params, function(response) {
            if (response === '') {
                console.warn("getEvento response is "+response);
                dispatch({ type: 'FETCH_FAILURE' });
            }
            const parsedData = parseMatchData(response, aggregata, match, isLive, compattaParametriche);
            dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
        });

        let interval;
        if(isLive) {
             const intervalMillis = getConfiguration()?.lpo ?? 10000;
             interval =   setInterval(() => {
                if(!ctxs?.betslipContext?.betInProgress) {
                    setIsSetInterval(true);
                    fetchData(url, params, function(response) {
                        const hasResponse = (response||null)!=null;
                        const parsedData = hasResponse ? parseMatchData(response, aggregata, match, isLive, compattaParametriche): {};
                        dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
                    });
                }
            }, intervalMillis);
        }
        
        return () => {
            didCancel = true;
            if(isLive){
                clearInterval(interval);
                setIsSetInterval(false);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match, aggregata, reload]);

    return [state, dispatch, isSetInterval];
}
